import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";
import { Reveal, SectionLabel } from "@/components/Reveal";

export const ForBuilders = () => {
  const { t } = useLanguage();

  return (
    <section
      id="builders"
      data-testid="builders-section"
      className="bg-ink py-24 md:py-36"
    >
      <div className="mx-auto max-w-[1600px] px-5 md:px-10">
        <div className="grid gap-10 md:grid-cols-12 md:gap-16">
          <div className="md:col-span-7">
            <Reveal>
              <SectionLabel text={t.builders.label} testId="builders-label" />
              <h2
                data-testid="builders-heading"
                className="mt-6 font-display text-4xl font-black uppercase leading-[0.95] tracking-tight text-white md:text-6xl"
              >
                {t.builders.heading}
              </h2>
            </Reveal>
          </div>
          <div className="flex flex-col justify-end md:col-span-5">
            <Reveal delay={0.15}>
              <p className="text-base leading-relaxed text-neutral-400 md:text-lg">
                {t.builders.intro}
              </p>
              <Link
                data-testid="builders-cta"
                to="/request-a-bid"
                className="group mt-8 inline-flex items-center gap-2 text-sm font-black uppercase tracking-[0.15em] text-gold transition-colors duration-300 hover:text-golddark"
              >
                {t.builders.cta}
                <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
              </Link>
            </Reveal>
          </div>
        </div>

        <div className="mt-16 grid gap-px overflow-hidden border border-white/10 bg-white/10 md:mt-24 md:grid-cols-3">
          {t.builders.chapters.map((ch, i) => (
            <Reveal key={ch.num} delay={i * 0.12} className="bg-ink">
              <div
                data-testid={`builders-chapter-${ch.num}`}
                className="group flex h-full flex-col p-8 transition-colors duration-500 hover:bg-charcoal md:p-12"
              >
                <span className="text-stroke-thin font-display text-6xl font-black leading-none md:text-8xl">
                  {ch.num}
                </span>
                <h3 className="mt-8 font-display text-2xl font-black uppercase tracking-tight text-white md:text-3xl">
                  {ch.title}
                </h3>
                <p className="mt-4 text-sm leading-relaxed text-neutral-400 md:text-base">
                  {ch.text}
                </p>
                <span className="mt-auto block pt-8">
                  <span className="block h-[3px] w-10 bg-gold transition-[width] duration-500 group-hover:w-full" />
                </span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
